



const API = "https://backendwhistler.herokuapp.com/api";
//const API = "http://localhost:8800/api"
export default API;